<template>
  <item-form />
</template>

<script>

import ItemForm from '@/views/Products/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ItemForm,
  },
  created() {
    this.$store.commit('products/RESET_DATA_ITEM')
  },
}
</script>
